'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateAccountLogin = function () {
  function TemplateAccountLogin(template) {
    (0, _classCallCheck3.default)(this, TemplateAccountLogin);

    this.el = template.el;
    this.ev = new _EventHandler2.default();

    this.ev.register(this.el.querySelector('.guest-login a'), 'click', this.submitGuestCheckout.bind(this));
  }

  (0, _createClass3.default)(TemplateAccountLogin, [{
    key: 'submitGuestCheckout',
    value: function submitGuestCheckout() {
      this.el.querySelector('#customer_login_guest').submit();
    }
  }, {
    key: 'unload',
    value: function unload() {
      this.ev.unregisterAll();
    }
  }]);
  return TemplateAccountLogin;
}();

exports.default = TemplateAccountLogin;